// src/index.js
import './scss/main.scss';

// Import your JavaScript modules
import './js/main.js';
